document.body.addEventListener('foundVariation', (event) => {
    const variation = event.detail.variation;
    window.custom = window.custom || {};
    window.custom.selectedVariant = variation;
});


document.addEventListener('click', async (e) => {
    if (!window.location.pathname.includes('/products')) return;

    const variation = window.custom?.selectedVariant;
    if (!variation) return CartToast.show('This variant is out of stock.', 'error');

    const atcBtn = e.target.closest('#customaddtocart');
    const buyBtn = e.target.closest('#custombuynow');

    if (atcBtn) {
        if (!variation.available) return CartToast.show('This variant is out of stock.', 'error');

        atcBtn.classList.add('is-loading');
        atcBtn.disabled = true;

        try {
            await window.cartDrawer?.addItem(variation.id, 1);
            window.cartDrawer?.open();
        } finally {
            atcBtn.classList.remove('is-loading');
            atcBtn.disabled = false;
        }
    }

    if (buyBtn) {
        e.preventDefault();
        if (!variation.available) return;

        buyBtn.classList.add('is-loading');
        buyBtn.disabled = true;

        try {
            const root = window.Shopify?.routes?.root ?? '/';

            await fetch(root + 'cart/clear.js', {
                method: 'POST'
            });

            const result = await window.cartDrawer?._request('cart/add.js', {
                items: [{
                    id: variation.id,
                    quantity: 1
                }]
            });

            if (result) window.location.href = root + 'checkout';

        } catch (err) {
            CartToast.show(err.message || 'Something went wrong.', 'error');
            buyBtn.classList.remove('is-loading');
            buyBtn.disabled = false;
        }
    }
});